export default function (state, value) {
  let auth = value.Login !== '_GHOST_USER_';
  state.loading = false;
  if (auth) {
    state.auth = true;
    state.id = value.MasterAgentUserId;
    state.name = value.Login;
    state.type = value.UserType;
    state.fullName = value.FullName;
    state.departmentName = value.Department;
    state.departmentId = value.DepartmentId;
    state.partnerId = value.PartnerId;
    state.needSelectDepartment = value.NeedSelectDepartment;
    state.partnerData = value.PartnerData;
    state.isSubAgent = value.PartnerData && value.PartnerData.IsSubAgent;
    state.isReservationCenter = value.PartnerData && value.PartnerData.IsReservationCenter;
    state.features = value.Features;
  }
}